// Core's map-validation issues (codes + params) worded in the current language.
import type { MapIssue, MapPlace } from '../../core/map/schema.js';
import { t, type Params } from './index.js';

export function mapIssueText(issue: MapIssue): string {
  const params: Params = { ...issue.params };
  if (typeof params.place === 'string') params.place = t(`mapPlace.${params.place as MapPlace}` as const);
  return t(`mapIssue.${issue.code}` as const, params);
}
